"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@flatfile/react");
var set_1 = __importDefault(require("lodash/set"));
var flatfileSettings_1 = __importDefault(require("./flatfileSettings"));
var dateReg = {
    'YYYY-MM-DD': '^[0-9]{4}-(((0[13578]|1[02])-(0[1-9]|[12][0-9]|3[0-1]))|(02-(0[1-9]|[12][0-9]))|((0[469]|11)-(0[1-9]|[12][0-9]|30)))$',
    'YYYY/MM/DD': '^[0-9]{4}/(((0[13578]|1[02])/(0[1-9]|[12][0-9]|3[0-1]))|(02/(0[1-9]|[12][0-9]))|((0[469]|11)/(0[1-9]|[12][0-9]|30)))$',
    'DD-MM-YYYY': '^(((0[1-9]|[12][0-9]|3[0-1])-(0[13578]|1[02]))|((0[1-9]|[12][0-9])-02)|((0[1-9]|[12][0-9]|30)-(0[469]|11)))-[0-9]{4}$',
    'DD/MM/YYYY': '^(((0[1-9]|[12][0-9]|3[0-1])/(0[13578]|1[02]))|((0[1-9]|[12][0-9])/02)|((0[1-9]|[12][0-9]|30)/(0[469]|11)))/[0-9]{4}$',
    'MM/DD/YYYY': '^(((0[13578]|1[02])/(0[1-9]|[12][0-9]|3[0-1]))|(02/(0[1-9]|[12][0-9]))|((0[469]|11)/(0[1-9]|[12][0-9]|30)))/[0-9]{4}$',
    'MM-DD-YYYY': '^(((0[13578]|1[02])-(0[1-9]|[12][0-9]|3[0-1]))|(02-(0[1-9]|[12][0-9]))|((0[469]|11)-(0[1-9]|[12][0-9]|30)))-[0-9]{4}$',
};
var FlatfileUpload = function (_a) {
    var customSettings = _a.customSettings, transactionsCaller = _a.transactionsCaller, children = _a.children, additionalSettings = _a.additionalSettings;
    var defaultFlatFileSettings = (0, flatfileSettings_1.default)();
    var settings = customSettings ? __assign({}, customSettings) : __assign({}, defaultFlatFileSettings);
    if (additionalSettings) {
        (0, set_1.default)(settings, 'fields[0].validators[1]', {
            validate: 'regex_matches',
            regex: dateReg[additionalSettings.dateFormat],
            error: "Date field value needs to be formatted as ".concat(additionalSettings.dateFormat, "."),
        });
    }
    return ((0, jsx_runtime_1.jsx)(react_1.FlatfileButton, __assign({ style: { padding: 0 }, licenseKey: "0871e726-0bc2-4ff6-80af-156b5f548d97", customer: { userId: '12345' }, settings: settings, onData: function (_a) {
            var validData = _a.validData;
            return __awaiter(void 0, void 0, void 0, function () {
                var transactionsData;
                return __generator(this, function (_b) {
                    transactionsData = validData.map(function (item) {
                        if (item.currency)
                            return item;
                        return __assign(__assign({}, item), { currency: additionalSettings === null || additionalSettings === void 0 ? void 0 : additionalSettings.defaultCurrency });
                    });
                    transactionsCaller(transactionsData);
                    return [2 /*return*/];
                });
            });
        } }, { children: children })));
};
exports.default = FlatfileUpload;
